import { z } from 'zod';

/** The search params of the detail pages, which each detail page's route picks */
export const detailSearchParams = z.object({
    history: z.enum(['metadata', 'placement']).optional().catch(undefined),
    isEditingContent: z.literal(true).optional().catch(undefined),
});

export type DetailSearchParams = z.output<typeof detailSearchParams>;
